import React from "react"
import { Accordion, Flex, Text, useMantineTheme } from "@mantine/core"
import { useStyles } from "@/pages/texting/components/PlaceholdersMenuDropdown/PlaceholdersMenuDropdown.styles"
import { Icon } from "@/components"
import type { AccordionSectionProps } from "@/pages/texting/types"

export const AccordionSection = ({ sectionName, items, icon, onSelection }: AccordionSectionProps) => {
    const { classes } = useStyles()
    const theme = useMantineTheme()

    return (
        <Accordion.Item value={sectionName}>
            <Accordion.Control className={classes.accordionControl}>
                <Flex gap={16} align="center">
                    <Icon
                        className={classes.accordionControlItem}
                        size="sm"
                        icon={icon.name}
                        iconFamily={icon.family}
                        color={theme.colors.violet[4]}
                    />
                    <span className={classes.accordionControlText}>{sectionName}</span>
                </Flex>
            </Accordion.Control>
            {items.map((item, key) => (
                <Accordion.Panel className={classes.accordionPanel} onClick={() => onSelection(item.value)} key={key}>
                    <Flex className={classes.accordionPanelFlex} align="center" justify="space-between">
                        <Text className={classes.placeholderLabel}>{item.label}</Text>
                        <Text className={classes.placeholderValue}>{item.value}</Text>
                    </Flex>
                </Accordion.Panel>
            ))}
        </Accordion.Item>
    )
}
